__turbopack_context__.v({
  "active": "index-module-scss-module___bbW-W__active",
  "arrow": "index-module-scss-module___bbW-W__arrow",
  "disable": "index-module-scss-module___bbW-W__disable",
  "page": "index-module-scss-module___bbW-W__page",
  "previous": "index-module-scss-module___bbW-W__previous",
  "withText": "index-module-scss-module___bbW-W__withText",
});
